<div class='grid-wrapper'>

  <kendo-gridlayout
    [cols]="['','']"
    [gap]="{ rows: 8, cols: 8 }"
    >
    <kendo-gridlayout-item [col]="1" [colSpan]="2" [rowSpan]="2">

      <div class="example-box" style="display:flex; justify-content: space-between; flex-wrap: wrap;">
        <div kendoTooltip position="top" style="display: inline-flex; gap: 8px;">
          <button type="button"
            class="inline-flex items-center gap-1.5 rounded-lg shadow border-0 cursor-pointer px-3 py-1.5 text-xs font-medium text-amber-900 bg-amber-50 hover:bg-amber-100 transition-colors disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:bg-amber-50"
            (click)="onCancelSelected()"
            [disabled]="!selection?.length"
            title="Cancel the selected approval requests">
            <i class="ms-Icon ms-Icon--Cancel" aria-hidden="true"></i>
            <span>Cancel{{ selection?.length ? ' (' + selection.length + ')' : '' }}</span>
          </button>
          <button type="button"
            class="inline-flex items-center gap-1.5 rounded-lg shadow border-0 cursor-pointer px-3 py-1.5 text-xs font-medium text-slate-600 bg-white hover:bg-slate-50 transition-colors"
            (click)="onExportAll()"
            title="Export every loaded approval to Excel (ignores selection)">
            <i class="ms-Icon ms-Icon--ExcelDocument" aria-hidden="true"></i>
            <span>Export All</span>
          </button>
        </div>

        <div>
          <span class="text-sm text-slate-500">Approvals is a <span class="pro-box"></span> subscription feature</span>
        </div>

      </div>
    </kendo-gridlayout-item>
  </kendo-gridlayout>

  <kendo-grid
    class="approvals"
    [data]="view"

    [sort]="state.sort"
    [sortable]="true"
    [filter]="state.filter"
    [selectable]="true"
    [kendoGridSelectBy]="'name'"
    [(selectedKeys)]="selection"

    filterable="menu"
    (dataStateChange)="dataStateChange($event)"
    [scrollable]="'virtual'"
    [rowHeight]="32"

    #approvalsgrid
    >
    <kendo-grid-checkbox-column
      [showSelectAll]="true"
      [width]="22"
      [style]="{'max-width':'22px', 'min-width':'22px', 'padding':'4px 0 4px 8px'}"
      [headerStyle]="{'max-width':'22px', 'min-width':'22px', 'padding':'4px 0 4px 8px'}"
    class="cell"></kendo-grid-checkbox-column>
    <kendo-grid-column field="approvalTitle" title="Title" [width]="200">
      <ng-template kendoGridCellTemplate let-dataItem>
        <div class='cell'>
          <a href='{{this.apiRoot}}/manage/environments/{{this.environment}}{{dataItem.approvalRequestUrl}}' title='{{dataItem.approvalDetails}}'
          target='_blank'>{{dataItem.approvalTitle}}</a>
        </div>
      </ng-template>
      <ng-template kendoGridFooterTemplate let-column="column">
        <span title='Total Connections'>{{this.approvalRequests.length}}&nbsp;</span>
        @if (this.loading$ | async) {
          <span><span class='k-icon k-i-loading' title='loading approvals'></span>...</span>
        }
      </ng-template>

    </kendo-grid-column>
    <kendo-grid-column field="approvalStatus" title="Status" [width]="100">
    </kendo-grid-column>
    <kendo-grid-column field="approvalOwner" title="Owner" [width]="100">
    </kendo-grid-column>
    <kendo-grid-column title="Assigned To" [width]="100">
      <ng-template kendoGridCellTemplate let-dataItem>
        @for (approver of dataItem.approvers; track approver) {
          <div style='margin-right:5px;'>@if (approver.approvalRequest) {
            <span class='ms-Icon ms-Icon--Contact'></span>
            }@if (!approver.approvalRequest) {
            <span class='k-icon k-i-checkbox-checked' title='This request has been completed.'></span>
          }{{approver.displayName}}</div>
        }
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="approvalItemDescription" title="Item" [width]="100" class="cell">
      <ng-template kendoGridCellTemplate let-dataItem>
        @if (dataItem.approvalItemLink) {
          <div class='cell'>
            <a href='{{dataItem.approvalItemLink}}' target='_blank'>{{dataItem.approvalItemDescription}}</a>
          </div>
        }
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="approvalCreationDate" title="Start" type="date" format="{0:y-MM-dd HH:mm:ss a}" filter="date" [width]="200">
    </kendo-grid-column>
    <kendo-grid-column field="Flow" title="Flow" [width]="100">
      <ng-template kendoGridCellTemplate let-dataItem>
        <div class='cell'>
          @if (dataItem.flowUrl) {
            <a href='{{this.apiRoot}}/manage/environments/{{this.environment}}{{dataItem.flowUrl}}' title='/manage/environments/{{this.environment}}{{dataItem.flowUrl}}'
            target='_blank'>Flow</a>
          }
        </div>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-excel fileName="approvalRequests.xlsx"></kendo-grid-excel>
  </kendo-grid>
  @if (!this.ready) {
    <div class="loading">
      <div class="k-i-loading"></div>
    </div>
  }
  <grid-context-menu [for]="approvalsgrid" [menuItems]="['Cancel']" (select)="onSelect($event)"></grid-context-menu>
</div>